import _typeof from "@babel/runtime/helpers/typeof";
import { FIELDS_CONFIG } from '../../fieldsConfig';
export function createFields(fields) {
  return fields.map(function (key) {
    if (_typeof(key) === 'object') {
      return key;
    }
    return FIELDS_CONFIG[key].field;
  });
}